<template>
  <el-row class="add-news">
    <el-col :span="12">
      {{ id ? "Yangilikni taxrirlash" : `Yangilik qo'shish` }}
    </el-col>
    <el-col :span="12" class="text-right">
      <router-link to="/app/news" class="el-button el-button--danger">
        Bekor qilish
      </router-link>
      <el-button @click="reactiveLink.show = true"> Havola yasash </el-button>
    </el-col>
    <el-col :span="24">
      <el-form label-position="top" ref="formRef" :model="newsModel">
        <el-tabs v-model="activeName">
          <el-tab-pane label="UZB" name="uz">
            <el-form-item
              label="Sarlavha"
              prop="titleUz"
              :rules="[{ required: true, message: 'Sarlavha majburiy (Uz)' }]"
            >
              <el-input
                placeholder="Sarlavhatni kiriting (Uz)"
                v-model.number="newsModel.titleUz"
                type="text"
                autocomplete="off"
              />
            </el-form-item>
            <el-form-item
              class="input-hidden"
              label="Asosiy matin (Uz)"
              prop="contentUz"
              :rules="[
                { required: true, message: 'Asosiy matin (Uz) majburiy' },
              ]"
            >
              <el-input
                hidden
                v-model.number="newsModel.contentUz"
                type="text"
                autocomplete="off"
              />
            </el-form-item>
            <QuillEditor
              :modules="modules"
              contentType="html"
              v-model:content="newsModel.contentUz"
              theme="snow"
              toolbar="full"
            />
          </el-tab-pane>
          <el-tab-pane label="RU" name="ru">
            <el-form-item
              label="Sarlavha"
              prop="titleRu"
              :rules="[{ required: true, message: 'Sarlavha majburiy (Ru)' }]"
            >
              <el-input
                placeholder="Sarlavhatni kiriting (Ru)"
                v-model.number="newsModel.titleRu"
                type="text"
                autocomplete="off"
              />
            </el-form-item>
            <el-form-item
              class="input-hidden"
              label="Asosiy matin (Ru)"
              prop="contentRu"
              :rules="[
                { required: true, message: 'Asosiy matin (Ru) majburiy' },
              ]"
            >
              <el-input
                hidden
                v-model.number="newsModel.contentRu"
                type="text"
                autocomplete="off"
              />
            </el-form-item>
            <QuillEditor
              contentType="html"
              v-model:content="newsModel.contentRu"
              theme="snow"
              toolbar="full"
            />
          </el-tab-pane>
          <el-tab-pane label="ENG" name="en">
            <el-form-item
              label="Sarlavha (En)"
              prop="titleEn"
              :rules="[{ required: true, message: 'Sarlavha majburiy (En)' }]"
            >
              <el-input
                placeholder="Sarlavhani kiriting (En)"
                v-model.number="newsModel.titleEn"
                type="text"
                autocomplete="off"
              />
            </el-form-item>
            <el-form-item
              class="input-hidden"
              label="Asosiy matn (En)"
              prop="contentEn"
              :rules="[
                { required: true, message: 'Asosiy matn (En) majburiy' },
              ]"
            >
              <el-input
                hidden
                v-model.number="newsModel.contentEn"
                type="text"
                autocomplete="off"
              />
            </el-form-item>
            <QuillEditor
              contentType="html"
              v-model:content="newsModel.contentEn"
              theme="snow"
              toolbar="full"
            />
          </el-tab-pane>
        </el-tabs>
        <div class="mt-15 form-row">
          <el-form-item
            class="file-upload"
            label="Sarlavha uchun rasm"
            prop="image"
            :rules="[
              { required: true, message: 'Sarlavha uchun rasm yuklang' },
            ]"
          >
            <el-input
              hidden
              v-model.number="newsModel.image"
              type="text"
              autocomplete="off"
            />
            <input
              accept="image/jpeg, image/jpg, image/png"
              type="file"
              @change="upload"
              hidden
              id="file"
              ref="uploadRef"
            />
            <label for="file" v-loading="fileLoader" class="file-upload-button">
              <div v-if="imgUrl">
                <img :src="imgUrl" alt="" />
              </div>
              Sarlavha uchun rasm yuklash
            </label>
          </el-form-item>
          <el-form-item
            label="Yuborish vaqti"
            prop="createdDate"
            :rules="[{ required: true, message: 'Yuborish vaqtini kiriting' }]"
          >
            <el-date-picker
              v-model="newsModel.createdDate"
              type="datetime"
              placeholder="Yuborish vaqti"
              format="DD.MM.YYYY HH:mm"
              value-format="x"
            />
          </el-form-item>
        </div>
        <div class="mt-15 text-right">
          <router-link to="/app/news" class="el-button el-button--danger">
            Bekor qilish
          </router-link>
          <el-button type="primary" @click="submitForm(formRef)"
            >Saqlash</el-button
          >
        </div>
      </el-form>
    </el-col>
  </el-row>

  <el-dialog
    v-model="reactiveLink.show"
    @close="reactiveLink.show = false"
    title="Mavjud Havolalar"
    align-center
  >
    <el-tabs v-model="reactiveLink.active" class="demo-tabs">
      <el-tab-pane label="Mavjud Havolalar" name="existing_links">
        <div class="linkButtons">
          <el-button
            v-if="reactiveLink.list.length"
            v-for="link in reactiveLink.list"
            :key="link.id"
            @click="onCopy(link.value)"
            >{{ link.title }}</el-button
          >
          <p v-else>Mavjud emas</p>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Yangi yaratish" name="new_link">
        <el-form
          label-position="top"
          size="large"
          :model="form"
          :rules="rules"
          ref="linkFormRef"
        >
          <el-row>
            <el-col :xs="24" :sm="18" :lg="16" :xl="14">
              <el-form-item label="" prop="file">
                <el-upload
                  v-model:file-list="reactiveLink.fileList"
                  ref="uploadRef"
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="uploadHeader"
                  :multiple="false"
                  :on-exceed="onLinkExceed"
                  :on-success="onLinkSuccessUpload"
                  :on-error="onLinkErrorUpload"
                >
                  <template #trigger>
                    <el-button style="width: 100%" type="secondary">
                      Havola faylni yuklang
                    </el-button>
                  </template>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script setup>
import { onBeforeMount, reactive, ref } from "vue";
import { ElMessage, ElNotification } from "element-plus";
import store from "@/store";
import http from "@/http";
import ImageUploader from "quill-image-uploader";
import router from "@/router";
import { useRoute } from "vue-router";

const uploadUrl = ref(
  `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`
);
const uploadHeader = ref({ Authorization: `${store.state.accessToken}` });
const baseUrl = process.env.VUE_APP_BASE_API_URL + "/api/v2/info/file/";
const formRef = ref();
const loading = ref(false);
const imgUrl = ref(null);
const reactiveLink = ref({
  show: false,
  active: "existing_links",
  fileList: [],
  list: [],
});
const fileLoader = ref(false);
const uploadRef = ref();
const activeName = ref("uz");
const route = useRoute();
const { id } = route.params;
const modules = {
  name: "imageUploader",
  module: ImageUploader,
  options: {
    upload: (file) => {
      return new Promise((resolve, reject) => {
        const fileValidate = beforeUploadFile(file);
        if (fileValidate) {
          const formData = new FormData();
          formData.append("file", file);
          const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
          http
            .post(url, formData, {
              headers: {
                Authorization: store.state.accessToken,
                "Content-Type": "multipart/form-data",
              },
            })
            .then(({ data }) => {
              console.log("Dataaa ", data);
              const imgUrl = baseUrl+data.hashId;
              resolve(imgUrl);
            })
            .catch((err) => {
              resolve(
                `Rasm yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`
              );
              console.log(err);
            })
            .finally(() => {
              fileLoader.value = false;
            });
        } else {
          reject("");
        }
      });
    },
  },
};
const newsModel = reactive({
  titleUz: "",
  titleRu: "",
  titleEn: "",
  contentUz: "",
  contentRu: "",
  contentEn: "",
  image: "",
  createdDate: new Date(),
});
const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      const updatedCreatedDate = new Date(newsModel.createdDate);
      updatedCreatedDate.setHours(updatedCreatedDate.getHours() + 5);

      loading.value = true;
      http({
        url: `api/v1/moderator-news${id ? `/${id}` : ""}`,
        data: {
          context_uz: newsModel.contentUz,
          context_ru: newsModel.contentRu,
          context_en: newsModel.contentEn,
          title_uz: newsModel.titleUz,
          title_en: newsModel.titleEn,
          title_ru: newsModel.titleRu,
          image: newsModel.image,
          active: true,
          created_date: updatedCreatedDate,
        },
        method: id ? "put" : "post",
        headers: {},
      })
        .then(() => {
          router.push("/app/moderator-news");
        })
        .catch((err) => {
          console.log(err);
          ElMessage.error(`Hatolik qayta urinib ko'ring`);
        })
        .finally(() => {
          loading.value = false;
        });
    } else {
      const errors = [];
      for (const keys in fields) {
        fields[keys].map((item) => {
          errors.push(item);
        });
      }
      errors.map((error) => {
        ElMessage.error(error.message);
      });
      console.log("error submit!", fields);
    }
  });
};
const upload = () => {
  fileLoader.value = true;
  const file = uploadRef.value.files[0];
  const isValidate = beforeUploadFile(file);
  if (isValidate) {
    const formData = new FormData();
    formData.append("file", file);
    http
      .post("api/v2/info/file/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(({ data }) => {
        imgUrl.value = baseUrl+data.hashId;
        newsModel.image = data.hashId;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        fileLoader.value = false;
      });
  }
};
const beforeUploadFile = (rawFile) => {
  if (!rawFile) {
    return false;
  }
  if (
    rawFile.type !== "image/jpeg" &&
    rawFile.type !== "image/png" &&
    rawFile.type !== "image/jpg"
  ) {
    ElMessage.error(`Sarlavha uchun rasm JPG, JPEG, PNG bo'lishi mumkin!`);
    return false;
  }
  if (rawFile.size / 1024 / 1024 > 5) {
    ElMessage.error(`Sarlavha uchun rasm xajmi max. 5Mb bo'lishi kerak!`);
    return false;
  }
  return true;
};
onBeforeMount(() => {
  if (id) {
    http.get(`api/v1/admin/moderator-news/${id}`).then(({ data }) => {
      console.log("Data ", data);
      newsModel.contentUz = data.context_uz;
      newsModel.contentRu = data.context_ru;
      newsModel.contentEn = data.context_en;
      newsModel.titleUz = data.title_uz;
      newsModel.titleRu = data.title_ru;
      newsModel.titleEn = data.title_en;
      newsModel.image = data.image;
      newsModel.createdDate = data.created_date;
      imgUrl.value = baseUrl+data.image;
    });
    console.log(id);
  }
});

const onCopy = (url) => {
  navigator.clipboard.writeText(url);
  ElMessage({
    message: "Nusxa olindi",
    grouping: true,
    type: "success",
  });
};

const createLink = (hashId) => {
  const foundLink = reactiveLink.value.fileList.find((item) => {
    if (item.status == "success" && item.response.hashId == hashId) {
      return item;
    }
  });

  if (foundLink) {
    const link = {
      id: foundLink.uid,
      value: `https://openbudget.uz/api/v2/info/file/${hashId}`,
      title: foundLink.name,
    };
    reactiveLink.value.list.push(link);
  }
};

const onLinkSuccessUpload = (res) => {
  console.log(reactiveLink.value);
  createLink(res.hashId);
  ElNotification.success({
    message: "Muvoffaqiyatli yuklandi",
  });
};

const onLinkErrorUpload = (error) => {
  ElNotification.error({
    message:
      "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
    type: "error",
  });

  loading.value = false;
};
const onLinkExceed = (files) => {
  console.log("exceeds", files);
  // this.form.file[0] = files[0]
};
</script>

<style>
.ql-editor {
  min-height: 100vh;
}

.file-upload label {
  margin: 0 !important;
}

.add-news .el-input__wrapper {
  padding: 0 1rem !important;
}

.input-hidden .el-form-item__content {
  height: 0;
  padding: 0;
}
</style>
<style scoped lang="scss">
.linkButtons {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
  width: 450px;
  button {
    width: 100%;
  }
}

.file-upload-button {
  padding: 1rem;
  border: 1px dotted #e1e1e1;
  border-radius: 8px;
  overflow: hidden;
  color: #808080;
  display: block;
  max-width: 240px;
  cursor: pointer;

  &:hover {
    background-color: #e1e1e1;
  }

  img {
    max-width: 100%;
    object-fit: cover;
  }
}

.text-right {
  text-align: right;
}

a {
  text-decoration: none;
}

.form-row {
  display: flex;
  gap: 15px;
}
</style>
